export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/bookedCarsIconGrey.b202808f.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};